export const YOUTUBE_RESOURCES = [
  {
    id: '1',
    title: 'How to Fix Windows 10/11 WiFi Connection Issues',
    description: 'Step-by-step guide to resolving the most common wireless networking problems on Windows machines.',
    category: 'Network',
    url: 'https://www.youtube.com/watch?v=qP2qWc35gOo',
    thumbnail_url: 'https://img.youtube.com/vi/qP2qWc35gOo/hqdefault.jpg' // Using generic YouTube thumbnail format
  },
  {
    id: '2',
    title: 'Troubleshooting Printer Offline Errors (All Brands)',
    description: 'Quickly get your wireless or wired printer back online without calling support.',
    category: 'Hardware',
    url: 'https://www.youtube.com/watch?v=F_Yv293wE_M',
    thumbnail_url: 'https://img.youtube.com/vi/F_Yv293wE_M/hqdefault.jpg'
  },
  {
    id: '3',
    title: 'How to Clear Browser Cache & Cookies (Chrome/Edge/Safari)',
    description: 'Resolve common login and web page loading errors with a simple cache clear.',
    category: 'Software',
    url: 'https://www.youtube.com/watch?v=vQJ4oZ8E1z0',
    thumbnail_url: 'https://img.youtube.com/vi/vQJ4oZ8E1z0/hqdefault.jpg'
  },
  {
    id: '4',
    title: 'Resetting Your Microsoft 365 / Outlook Password',
    description: 'Self-service guide to regaining access to your work email and Office suite.',
    category: 'Access',
    url: 'https://www.youtube.com/watch?v=2e0oB0v_bJk',
    thumbnail_url: 'https://img.youtube.com/vi/2e0oB0v_bJk/hqdefault.jpg'
  },
  {
    id: '5',
    title: 'Fixing A Slow Computer: 5 Easy Steps',
    description: 'Optimize performance and close background processes slowing down your workstation.',
    category: 'Hardware',
    url: 'https://www.youtube.com/watch?v=x0X0G7W_M9U',
    thumbnail_url: 'https://img.youtube.com/vi/x0X0G7W_M9U/hqdefault.jpg'
  },
  {
    id: '6',
    title: 'Resolving Teams and Zoom Microphone/Camera Issues',
    description: 'Ensure your audio and video are working perfectly before your next meeting.',
    category: 'Software',
    url: 'https://www.youtube.com/watch?v=O1_X3w3o5_o',
    thumbnail_url: 'https://img.youtube.com/vi/O1_X3w3o5_o/hqdefault.jpg'
  },
  {
    id: '7',
    title: 'Understanding VPNs (Virtual Private Networks) for Remote Work',
    description: 'How to connect to the company VPN and what to do if it fails.',
    category: 'Network',
    url: 'https://www.youtube.com/watch?v=Wji2V0v_w6c',
    thumbnail_url: 'https://img.youtube.com/vi/Wji2V0v_w6c/hqdefault.jpg'
  },
  {
    id: '8',
    title: 'How to set up Two-Factor Authentication (2FA)',
    description: 'Secure your corporate accounts easily using authenticator apps.',
    category: 'Access',
    url: 'https://www.youtube.com/watch?v=0h5U3g0iH4A',
    thumbnail_url: 'https://img.youtube.com/vi/0h5U3g0iH4A/hqdefault.jpg'
  }
];

export const VIDEO_CATEGORIES = ['All', 'Hardware', 'Software', 'Network', 'Access'];
